<template>
  <section class="bg-black text-white font-sans py-16 sm:py-24">
    <div class="container mx-auto px-4">

      <h2 class="text-center text-4xl md:text-5xl font-bold tracking-tight">
        Conheça a nossa equipe<br />
        de <span class="text-orange-500">colaboradores</span>
      </h2>

      <div class="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 justify-items-center">
        
        <div 
          v-for="collab in collaborators" 
          :key="collab.name" 
          class="text-center flex flex-col items-center"
        >
          
          <img 
            :src="collab.image" 
            :alt="'Foto de ' + collab.name" 
            class="rounded-3xl aspect-[3/4] w-full max-w-[280px] object-cover mb-6 transition-all duration-300 hover:shadow-xl hover:shadow-orange-500/20 hover:-translate-y-2"
          />
          
          <div class="px-2">
            <h3 class="text-xl font-bold text-orange-500">{{ collab.name }}</h3>
            
           <p class="mt-2 text-base text-gray-300 leading-relaxed text-justify">
            {{ collab.role }}
          </p>

            
            <div class="mt-4 w-20 h-1 bg-orange-500 mx-auto rounded-full"></div>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script>
import image1 from '@/assets/1.jpg';
import image2 from '@/assets/2.jpeg';
import image3 from '@/assets/3.jpeg';

export default {
  name: 'TeamSection',
  data() {
    return {
      collaborators: [
        {
          name: 'Jesuino Filho',
          role: 'Jesuino Filho é estudante de Gestão da Inovação e especialista em Gestão da Qualidade e Inovação. Com experiência em projetos de gestão de processos e negócios, ele é o idealizador do projeto Overx. Comprometido em fomentar a inovação em um mercado em constante crescimento, Jesuino acredita na importância da inovação contínua para o sucesso das empresas.',
          image: image1,
        },
        {
          name: 'Rafael Faccin',
          role: 'Com mais de 15 anos de experiência em manutenção siderúrgica, vendas e administração, lidero equipes com uma visão estratégica dos processos de negócio. Atualmente, aplico minha expertise técnica e gerencial para desenvolver soluções eficientes, priorizando comunicação clara, proximidade com os clientes e foco em resultados consistentes.',
          image: image2,
        },
        {
          name: 'Euquias Júnior',
          role: 'Cursou Administração e foi co-founder da fintech Genezys, primeira investida da Solana Blockchain na LATAM. Especialista em Blockchain pela UC Berkeley, atua em produto e operações.',
          image: image3,
        },
      ]
    }
  }
}
</script>